import { Component, ViewEncapsulation,Input, Output, EventEmitter, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { AuthService } from './../../../app/services/auth.service';
import { ProductViewDataService } from './../../services/product-view-data.service';
import { ProductViewHelperService } from './../../services/product-view-helper.service';
import { LoaderService } from '../../../app/services/loader.service';
import { Subscription } from 'rxjs';
import { GigyaSessionService } from '../../../app/services/gigya-session.service';
import { AppHelperService } from '../../../app/services/app-helper.service';
import { ProductTocService } from './../../services/product-toc.service';
import { ThemeService } from "libs-frontend-micro-base";
import { TranslateService } from '@ngx-translate/core';
import { HtmlMetaManagerService } from 'modules/app/services/html-meta-manager.service';
import { appSetting } from '../../../../config/appSettings';
@Component({
    selector: 'lo-renderer',
    templateUrl: './lo-renderer.template.html',
    styleUrls: ['./lo-renderer.style.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class LORenderer implements OnInit, OnDestroy {
  selectedItemSubscription: Subscription;
  saveAlertActionOnLogoutSubscription : Subscription;
  currentActivityId: string;
  selectedActivity: any;
  unitIndex: number;
  lessonIndex: number;  
  activityIndex: number;
  @Input() learningpathVisible: boolean;  
  @Output() learningpathVisibleChange = new EventEmitter<boolean>();
  @Output() navigateBackEvent = new EventEmitter<boolean>();
  @Input() previewMode: string;
  @Input() isPreviewMode: boolean;
  @Input() tocArray : any[];
  @Input() selectedItem : any;
  @Input() hideSequencing : string;
   /* Boolean to show/hide the activity container */
  @Input() showResultScreen: boolean;
  @Input() showLitmusUnavailableScreen: boolean;
  @Input() bundleTitle: string;
  public showAssignmentOnlyComponentBanner: boolean;
  public isTeacher: boolean;
  tocFolderDepth: number;
  lessonSequence: string;
  showBanner: boolean = false;
  showLtiResultScreen:boolean = false
  isHideBackButton:boolean = false;
  userData: any;
  tocIcon: string;
  themeService;
  private activityEventsSubscription: Subscription;
  private paramsSubscription: Subscription;

  public imageBasePath: string = IMAGES_BASEPATH;
  public showFullScreen: boolean = false;
  public isSCompContent: boolean = false;
  public isAssignedLO: boolean = false;

  constructor(private gigyaSessionService: GigyaSessionService,
    private router: Router,
    private authService: AuthService,
    private productViewDataService: ProductViewDataService,
    private loaderService: LoaderService,
    private productViewHelperService: ProductViewHelperService,
    private appHelperService : AppHelperService,
    private productTocService: ProductTocService,
    private route: ActivatedRoute,
    private htmlMetaManagerService: HtmlMetaManagerService,
    private translate: TranslateService ) {
      this.themeService = new ThemeService();
    }

  ngOnInit() {
    this.tocFolderDepth = this.productTocService.getTocNodeCount(this.tocArray);
    if(this.tocFolderDepth == 0){
      this.hideSequencing = 'true';
    }

    this.userData = this.authService.getUserData();
    this.isHideBackButton = this.userData && this.userData.launchType == 'lti' && ['ltd', 'ltc'].indexOf(this.route.snapshot.queryParams.lf) === -1;
    const currentTheme = this.themeService.getActiveTheme().meta; 
    this.tocIcon = (currentTheme && currentTheme.id === 'primary') ? 'nav-icon-primary.svg' : 'nav-icon.svg';
    this.selectedItemSubscription = this.productViewHelperService.selectedItemId.subscribe((selectedItemObject: any) => {
      // Added settimeout to fix "Expression has changed after it was checked" error
      setTimeout(() => {
        this.currentActivityId = selectedItemObject?.itemid;
        this.selectedActivity = selectedItemObject?.selectedItemData;
        this.showLtiResultScreen = selectedItemObject?.showLtiResultScreen;
        this.setLessonSequence();

        if (!selectedItemObject) return;

        this.isSCompContent = this.selectedActivity?.[this.selectedActivity["sub-type"]]?.container === 'scomp-container';

        if (this.isSCompContent) {
          this.htmlMetaManagerService.setTitle(this.translate.instant("HTML_META.SCOMP_ACTIVITY_VIEW.TITLE", { ActivityName: this.selectedActivity.name }), this.bundleTitle);
          this.htmlMetaManagerService.setDescription(this.translate.instant("HTML_META.SCOMP_ACTIVITY_VIEW.DESCRIPTION"));
        } else {
          this.htmlMetaManagerService.setTitle(this.selectedActivity.name + this.translate.instant("HTML_META.MAIN.CUSTOM_TITLE"));
        }
      })
    });

    this.paramsSubscription = this.route.params.subscribe((params: Params) => {
      const bundleDetails = this.route.snapshot.data.resolveData.productData.bundleDetails;
      const productCode = params.productcode;
      const bundleProduct = bundleDetails.products.find((bP) => bP['dls-product']['code'] === productCode);
      this.isAssignedLO = !!params.assignmentid;
      const key = appSetting.localStorage.assignmentOnlyComponentBanner(this.userData.extUserId)
      if (localStorage.getItem(key) !== "false" && bundleProduct.activation?.gated?.student?.["assignments-only"] && this.userData?.launchType !== 'lti') {
        this.showAssignmentOnlyComponentBanner = true;
      }
    });
    this.showBanner = this.route.snapshot.queryParams['showMessageBanner'] === 'true';
    if (this.router.url && this.router.url.indexOf("/teacher/") !== -1) {
      this.isTeacher = true;
    }

    // Subscribe to activity events. This is used for activity fullscreen functionality in scomp activities.
    this.activityEventsSubscription = this.productViewHelperService.activityEventsSubject.subscribe(({ containerEvent, containerEventData }) => {
      // Don't show fullscreen for teacher view assignment
      if (containerEvent === 'fullScreen' && (!this.isAssignedLO || this.userData?.role === 'student')) {
        this.showFullScreen = containerEventData;
      }
    });
  }
  setLessonSequence(){
    if(this.hideSequencing !== 'true'){
      let levelSequence = this.selectedActivity?.sequence?.split(".");
      levelSequence?.pop();
      this.lessonSequence = levelSequence?.join(".");
    }
  }
  toggleSideBar() {
    this.learningpathVisible = this.learningpathVisible ? false : true;
    this.learningpathVisibleChange.emit(this.learningpathVisible);

    // Set focus to back button when sidebar is opened
    setTimeout(() => {
      const unitLevelBackBtn = document.getElementById('unitViewBackBtn');
      const lessonLevelBackBtn = document.getElementById('lessonViewBackBtn');
      if (unitLevelBackBtn) {
        unitLevelBackBtn.focus();
      } else if (lessonLevelBackBtn) {
        lessonLevelBackBtn.focus();
      }
    }, 100);
  }
  startLoader() {
    this.loaderService.showOverlayLoader();
  }
  navigateToDashboard() {
    const { queryParams, params } = this.route.snapshot;
    if(queryParams.lf == 'ltd') {
      this.appHelperService.navigateToOnboardingApp(['lti-teacher-dashboard', params.spaceid, 'class', queryParams.cid, 'ltik', queryParams.ltik]);
    } else if(queryParams.lf == 'ltc') {
      this.appHelperService.navigateToOnboardingApp(['lti-component-selection', params.spaceid, 'class', queryParams.cid, 'bundle', queryParams.bcode, 'resource', queryParams.rcode, 'ltik', queryParams.ltik]);
    } else {
      this.appHelperService.showLoaderAndNavigateToDashboard(this.userData);

    }
  }

  logOut() {
    if(this.saveAlertActionOnLogoutSubscription) {
      this.saveAlertActionOnLogoutSubscription.unsubscribe();
    }
    //This is done to logout only after handling the save alert popup case
    this.saveAlertActionOnLogoutSubscription = this.productViewHelperService.saveAlertActionOnLogout.subscribe(()=> {
        //this.productViewDataService.classOrProductViewCache.clear();
        this.loaderService.showOverlayLoader();
        if (this.isPreviewMode) {
          // Logout the user directly if preview mode
          return this.logoutUser();
        }
        this.productViewHelperService.getXAPIAnalyticsObject().flushStateAndStatements().then((response) => {
          this.logoutUser();  
        },(error)=> {
          //Log out user even in case of error while submitting statements
          this.logoutUser();
        }).catch((error)=> {
          //Log out user even in case of error while submitting statements
          this.logoutUser();
        });
    })
    //Needed for Activity launch to show alert if needed
    this.productViewHelperService.logOutCalled.next();
  }

  closeAssignmentOnlyComponentBanner(dontShowAgain: boolean = false) {
    const userid = this.userData.extUserId;
    if (dontShowAgain) localStorage.setItem(appSetting.localStorage.assignmentOnlyComponentBanner(userid), 'false');
    this.showAssignmentOnlyComponentBanner = false;
  }

  private logoutUser() {
    // Auth Service Logout
    this.authService.logOut().toPromise().then(
      (res) => {
        if (res.success) {
          this.authService.clearUserdata();
          // Gigya Service Logout
          return this.gigyaSessionService.gigyaLogout();
        }
      }
    ).then(() => {
      // On Logout nabvigate to home page
      this.appHelperService.navigateToOnboardingApp(['home']);
    });
  }

  ngOnDestroy() {
      if (this.selectedItemSubscription) {
        this.selectedItemSubscription.unsubscribe();
      }
      if(this.saveAlertActionOnLogoutSubscription) {
        this.saveAlertActionOnLogoutSubscription.unsubscribe();
      }
      if (this.paramsSubscription) {
        this.paramsSubscription.unsubscribe();
      }
      this.activityEventsSubscription?.unsubscribe();
  }

  navigateBack() {
    this.navigateBackEvent.emit();
  }
}
